import React, { useState } from "react"
import PropTypes from "prop-types"
import { CloseOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import AssetNumbersModal from "../AssetNumbersModal"
import styles from "./index.module.css"

const EquipmentTable = ({ equipment, onAction, actionType, emptyMessage, canEdit, loading }) => {
  const { t } = useTranslation()
  const [modalItem, setModalItem] = useState(null)

  const renderAssetNumber = (item) => {
    if (Array.isArray(item.assetNumbers) && item.assetNumbers.length > 0) {
      const first = item.assetNumbers[0]
      const remaining = item.assetNumbers.length - 1
      return (
        <span>
          {first}
          {remaining > 0 && (
            <button
              className={styles.assetBadge}
              onClick={(e) => {
                e.stopPropagation()
                setModalItem(item)
              }}
            >
              +{remaining}
            </button>
          )}
        </span>
      )
    }
    return <Text>{item.assetNumber}</Text>
  }

  return (
    <>
      <div className={styles.tableContainer}>
        <div className={styles.tableHeader}>
          <div className={styles.equipmentColumn}>
            <Text className={styles.headerText}>{t("booking.equipment.equipment")}</Text>
          </div>
          <div className={styles.assetNumberColumn}>
            <Text className={styles.headerText}>{t("booking.equipment.asset_number")}</Text>
          </div>
          <div className={styles.categoryColumn}>
            <Text className={styles.headerText}>{t("booking.equipment.category")}</Text>
          </div>
          {canEdit && (
            <div className={styles.actionColumn}>
              <Text className={styles.headerText}>{t(`booking.equipment.${actionType}`)}</Text>
            </div>
          )}
        </div>

        {equipment.length === 0 ? (
          <div className={styles.centeredRow}>
            <Text>{emptyMessage}</Text>
          </div>
        ) : (
          equipment.map((item) => (
            <div key={item.id} className={styles.tableRow}>
              <div className={styles.equipmentColumn}>
                <Text>{item.name}</Text>
              </div>
              <div className={styles.assetNumberColumn}>{renderAssetNumber(item)}</div>
              <div className={styles.categoryColumn}>
                <Text>{item.category}</Text>
              </div>
              {canEdit && (
                <div className={styles.actionColumn}>
                  <button
                    className={actionType === "unassign" ? styles.unassignButton : styles.assignButton}
                    onClick={() => onAction(item)}
                    disabled={loading}
                  >
                    {loading ? <LoadingOutlined /> : actionType === "unassign" ? <CloseOutlined /> : <PlusOutlined />}
                  </button>
                </div>
              )}
            </div>
          ))
        )}
      </div>

      {modalItem && (
        <AssetNumbersModal
          open
          onClose={() => setModalItem(null)}
          equipmentName={modalItem.name}
          assetNumbers={modalItem.assetNumbers}
        />
      )}
    </>
  )
}

EquipmentTable.propTypes = {
  equipment: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      assetNumber: PropTypes.string,
      assetNumbers: PropTypes.arrayOf(PropTypes.string),
      category: PropTypes.string.isRequired
    })
  ).isRequired,
  onAction: PropTypes.func.isRequired,
  actionType: PropTypes.oneOf(["assign", "unassign"]).isRequired,
  emptyMessage: PropTypes.string.isRequired,
  canEdit: PropTypes.bool,
  loading: PropTypes.bool
}

export default EquipmentTable
